export const getPathname = (
    pathname: string,
    searchType: 'for-sale' | 'to-rent' | 'new-homes'
) => {
    const pathRegex = /for-sale|to-rent|new-homes/;

    return pathname.replace(pathRegex, searchType);
};
